<template>
  <ul class="NavLinks">
    <li class="navbar-item">
      <a href="#services">Services</a>
    </li>
    <li class="navbar-item">
      <a href="#our-work">Our Work</a>
    </li>
    <!-- <li class="navbar-item">
      <a href="#">Process</a>
    </li> -->
    <li class="navbar-item">
      <a href="#profile">Profile</a>
    </li>
    <li class="navbar-item">
      <a href="#testimonials">Testimonials</a>
    </li>
    <li class="navbar-item">
      <a href="#contact">Contact</a>
    </li>
  </ul>
</template>
<script>
export default {
    name: 'NavLinks',
    components: {},
    computed: {},
    mounted() {},
    data() {
        return {};
    },
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

.NavLinks {
    display: flex;
    flex-direction: column;

    li {
        margin-left: 5px;

        a {
            font-weight: 300;
            font-style: normal;
            color: $white;
            text-decoration: none;
        }
    }

    @media screen and (min-width: 1088px) {
        flex-direction: row;

    }
}

.Footer .NavLinks {
    flex-direction: column;
    li {
        margin-left: 0;
        border-bottom: 1px solid $white;
        padding: 0;
        a {
            font-weight: normal;
            line-height: 28px;
        }
    }
}
</style>
